import type Point from "./Point";
import triangleArea from "./triangleArea";

export default function isInsideRect(a:Point, b:Point, c:Point, d:Point, point:Point) {
	// Allow a few floating-point rounding steps when a point lies on an edge.
	const tolerance = 8 * Number.EPSILON * Math.max(1,
		Math.abs(a.x), Math.abs(a.y), Math.abs(b.x), Math.abs(b.y),
		Math.abs(c.x), Math.abs(c.y), Math.abs(d.x), Math.abs(d.y),
		Math.abs(point.x), Math.abs(point.y));
	const isOutsideEdge = (start:Point, end:Point) => {
		// Triangle area is half the edge length times the signed distance.
		const edgeLength = Math.hypot(end.x - start.x, end.y - start.y);
		return triangleArea(start, end, point) > tolerance * edgeLength / 2;
	};

	return !isOutsideEdge(a, b) && !isOutsideEdge(b, c) &&
		!isOutsideEdge(c, d) && !isOutsideEdge(d, a);
};
